import ApplicationEmptyState from './ApplicationEmptyState.component';

export default ApplicationEmptyState;
